import {ENTRY_FIELD_DEFINITIONS, ENTRY_FIELDS, EntryField, EntryInput, EntryRule} from "@library/domain/recruit/EntryField";
import {InputRule} from "@library/domain/validation/InputRule";

/**
 * 項目ごとの最初の違反（サーバ側の CI4 も項目ごとに最初の違反だけを返す）
 */
export type EntryViolation = {
    readonly field: EntryField;
    readonly rule: EntryRule;
};

/**
 * 採用エントリーの入力を検証するユースケース。
 */
export class ValidateEntryUseCase {
    readonly #today: Date;

    /**
     * @param today 今日の日付（生年月日の上限。テストで固定できるように引数にする）
     */
    public constructor(today: Date = new Date()) {
        this.#today = today;
    }

    /**
     * 違反を項目の並び順で戻す（違反が無ければ空の配列）
     */
    public execute(input: EntryInput): EntryViolation[] {
        const violations: EntryViolation[] = [];

        for (const field of ENTRY_FIELDS) {
            // サーバ側と同じく、前後の空白を除いてから検証する
            const value = input[field].trim();
            const violated_rule = ENTRY_FIELD_DEFINITIONS[field].rules.find((rule) => !this.#isValid(value, rule));
            if (violated_rule !== undefined) {
                violations.push({field: field, rule: violated_rule});
            }
        }

        return violations;
    }

    #isValid(value: string, rule: EntryRule): boolean {
        switch (rule.name) {
            case "required":
                return InputRule.required(value);
            case "max_length":
                return InputRule.maxLength(value, rule.param ?? Number.MAX_SAFE_INTEGER);
            case "valid_email":
                return InputRule.validEmail(value);
            case "valid_birthday":
                return InputRule.validBirthday(value, this.#today);
            case "valid_tel":
                return InputRule.validTel(value);
            case "no_control_chars":
                return InputRule.noControlChars(value);
            case "single_line":
                return InputRule.singleLine(value);
        }
    }
}
